import { type TDeviceType } from '@cian/ui-kit';

import { type TParallaxGeneralContext } from 'shared/types/bannerContext';

import { toCssImageUrl } from 'shared/utils/toCssImageUrl';

import { pickImageUrl } from './getImageUrl';

/** Сырой URL фоновой картинки по типу устройства — для предзагрузки в хуке параллакса. */
export const getBackgroundImageSrc = (context: TParallaxGeneralContext, deviceType: TDeviceType): string =>
  pickImageUrl(deviceType, context.backgroundImageUrl, context.mobBackgroundImageUrl);

export const getBackgroundImageUrl = (context: TParallaxGeneralContext, deviceType: TDeviceType): string =>
  toCssImageUrl(getBackgroundImageSrc(context, deviceType));
